import { render, staticRenderFns } from "./TechnologicalDevelopmentsPg.vue?vue&type=template&id=6639219c&scoped=true&"
import script from "./TechnologicalDevelopmentsPg.vue?vue&type=script&lang=js&"
export * from "./TechnologicalDevelopmentsPg.vue?vue&type=script&lang=js&"
import style0 from "./TechnologicalDevelopmentsPg.vue?vue&type=style&index=0&id=6639219c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6639219c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
